export enum ContractStatus {
  STARTED = 'STARTED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
  DELETED = 'DELETED'
}
